<template>
  <component :is="headingTag" class="decoration-head">
    {{ text }}
  </component>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    headingLevel: {
      type: Number,
      required: false,
      default: 2
    }
  },
  computed: {
    headingTag() {
      return `h${this.headingLevel}`
    }
  }
}
</script>
<style lang="scss" scoped>
.decoration-head {
  display: flex;
  background-color: $white;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.6;
  box-sizing: border-box;
  border-bottom: 1px $gray-2 solid;
  padding: 16px 24px;

  @media all and (max-width: $base-contents-width - 1) {
    padding: 20px 16px;
  }
}
</style>
